import {Entity} from "../../../helpers/Entity"

export type SerialNumberElasticDto = {
    id: string
    accountId: string
    archived: boolean
    isAvailable: boolean
    serial: string
    productId: string
    createdByUserId: string
    createdAt: string
    updatedByUserId: string
    updatedAt: string
    deletedByUserId: string
    deletedAt: string
    history: SerialNumberHistoryElasticDto[]
}

export type SerialNumberHistoryElasticDto = {
    contactId: string
    rowId: string
    saleId: string
    saleType: string
    identifier: string
    transactionDate: Date
}

export class SerialNumberElastic implements Entity {
    private dto: SerialNumberElasticDto

    constructor(dto: SerialNumberElasticDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return true
    }

    isAvailable(): boolean {
        return this.dto.isAvailable
    }

    getId(): string {
        return this.dto.id
    }

    getSerial(): string {
        return this.dto.serial
    }

    getHistory(): SerialNumberHistoryElasticDto[] {
        return this.dto.history
    }

    getMostRecentActiveSale(): SerialNumberHistoryElasticDto | null {
        if (!this.isAvailable() && this.getHistory().length > 0) {
            return this.getHistory()[this.getHistory().length - 1]
        }

        return null
    }
}


// WEBPACK FOOTER //
// ./src/state/listing/serial-numbers/models/serialNumberElastic.ts